module.exports = __webpack_public_path__ + "static/reward.afe2bd24.png";